'use client';

import { usePathname, useRouter } from 'next/navigation';
import { NavbarShared } from './NavbarShared';

export const NavbarApp = () => {
    const pathname = usePathname();
    const router = useRouter();

    const handleSearch = (term: string) => {
        router.push('/search/' + encodeURIComponent(term), {
            scroll: true
        });
    };

    return <NavbarShared pathname={pathname} onSearch={handleSearch} />;
};
